//This function fills the gap of browsers that DO load nomodule scripts (and thus do not get polyfills loaded by Next)
//but DO NOT support intersection-observer natively.

const hasIntersectionObserver = () => {
  if (typeof window === "undefined") return;
  //check for native intersection observer support
  //if it doesnt exist, return false
  //if it does, return true
  if (
    !("IntersectionObserver" in window) ||
    !("IntersectionObserverEntry" in window) ||
    !("intersectionRatio" in window.IntersectionObserverEntry.prototype)
  ) {
    return false;
  }
  return true;
};

export default hasIntersectionObserver;
